import { render, staticRenderFns } from "./AdminReviewForm.vue?vue&type=template&id=39716c0d&"
import script from "./AdminReviewForm.vue?vue&type=script&lang=js&"
export * from "./AdminReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports